import { useFormContext } from 'react-hook-form';
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { JawsScanUpdate } from '@schema/jawsScan.ts';

export default function EditNotesForm() {
  const form = useFormContext<JawsScanUpdate>();

  return (
    <Form {...form}>
      <div className="flex flex-col gap-4 text-white">
        <header className="space-y-1">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/60">Notes</p>
          <h3 className="text-lg font-semibold tracking-tight">Update treatment notes</h3>
          <p className="text-sm text-white/60">Summarise observations or instructions for this scan.</p>
        </header>

        <FormField
          control={form.control}
          name="note"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs font-semibold uppercase tracking-[0.3em] text-white/60">Notes</FormLabel>
              <FormControl>
                <Textarea
                  rows={8}
                  className="rounded-2xl border border-content-highlight/35 bg-content-dark/45 text-sm text-white shadow-inner shadow-primary/10 focus:border-primary/60 focus:ring-2 focus:ring-primary/40"
                  {...field}
                  value={field.value ?? ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </Form>
  );
}
